<template>
  <div class="pending-benefit-approval">
    <div class="main">
      <div class="left">
        <div class="project-details" v-if="benefitApproval.benefit && benefitApproval.benefit.project">
          <label v-if="benefitApproval.benefit.project.category">{{benefitApproval.benefit.project.category.name}}</label>
          <h4
            class="title"
            @click="goToProject"
          >
            {{ benefitApproval.benefit.project.name }}
          </h4>
        </div>

        <div class="approval-values">

          <div>
            <label>Realised Value</label>
            <span>{{formatCurrency(benefitApproval.realizedAmount)}}</span>
          </div>

          <div>
            <label>Saving Type</label>
            <span>{{org.savingsTypes.find(el => el.id === benefitApproval.benefit.savingsTypeId).name}}</span>
          </div>

          <div>
            <label>Financial year</label>
            <span>{{years.find(el => el.value === benefitApproval.benefit.yearEnding).text}}</span>
          </div>

          <div>
            <label>Realised Date</label>
            <span>{{formatDate(benefitApproval.realizedDate)}}</span>
          </div>

        </div>
      </div>
      <div class="right">
        <div class="approval-status">
          <span>{{`Submitted by ${users[benefitApproval.requesterId].name} on ${formatDate(benefitApproval.createdAt)}`}}</span>
        </div>
        <transition name="fade">
          <div v-if="!response" class="response-actions">
            <div class="icon check" @click="response = 'Approved'" />
            <div class="icon clear" @click="response = 'Rejected'" />
          </div>
        </transition>
      </div>
    </div>
    <transition name="slide-y">
      <div v-if="response" class="expansion">
        <div class="comments">
          <material-input
            v-if="response === 'Rejected'"
            v-model="benefitApproval.responderNotes"
            type="textarea"
            label="Reason for Rejection"
            :required="false"
            name="EnterComment"
          />
        </div>

        <div class="d-flex align-items-end">
          <a class="button secondary-button dense" @click="response = null" :disabled="loading">
            Cancel
          </a>
          <a class="button outlined dense" @click="submitApprovalResponse" :disabled="loading">
            {{response === 'Approved' ? 'Approve' : 'Reject'}}
          </a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import fy_months from "@/utils/fy_months";
import {mapGetters} from "vuex";
import moment from "moment";
import currSymbol from "currency-symbol-map";
import MaterialInput from "@/components/MaterialInput";
import numeral from "numeral";

export default {
  name: "PendingBenefitApproval",
  components: {MaterialInput},
  props: {
    benefitApproval: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    response: null,
    loading: false
  }),
  methods: {
    goToProject(){
      // this.$router.push({ name: 'ProjectDetail', params: { id: this.benefitApproval.benefit.project.shortId } });
    },
    getYearOption(offset) {
      const target_year = new Date().getFullYear() + offset;
      const year = fy_months(this.$store.getters.org.fy_month, target_year)
        .year;

      return {
        value: target_year,
        text: year,
      };
    },
    formatDate(val){
      const date = moment(val)
      return date.isValid() ? date.format('DD MMM YYYY') : ''
    },
    getCurrencySymbol() {
      return currSymbol(this.currencyCodeById(this.benefitApproval.benefit.project.currencyId));
    },
    formatCurrency(val){
      return this.getCurrencySymbol() + numeral(val).format('0,0.[00]')
    },
    submitApprovalResponse(){
      this.loading = true;
      this.$store.dispatch('submitApprovalResponse', {
        id: this.benefitApproval.id,
        status: this.response,
        responderNotes: this.benefitApproval.responderNotes
      })
        .catch((e) => {
          console.error(e);
          this.loading = false;
        })
    }
  },
  computed: {
    ...mapGetters(['currencyCodeById', 'org', 'users']),
    year() {
      const date = new Date();
      return date.getFullYear();
    },
    years() {
      return [
        this.getYearOption(-2),
        this.getYearOption(-1),
        this.getYearOption(0),
        this.getYearOption(1),
        this.getYearOption(2),
        this.getYearOption(3),
        this.getYearOption(4),
        this.getYearOption(5),
      ];
    },

  }
}
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.pending-benefit-approval {
  background-color: white;
  border: 1px solid #e2e5ec;
  border-radius: 4px;
  margin-bottom: 15px;
  padding: 15px 25px;
  transition: all 0.5s;

  .main {
    display: flex;
    //flex-wrap: nowrap;
    justify-content: space-between;
    div.right {
      width: 500px;
      min-width: 500px;
      max-width: 500px;
      align-self: stretch;
      display: flex;
      flex-direction: column;
      justify-content: space-between;



      .approval-status {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 10px;
        span {
          font-size: 12px;
          color: $sidebar-color;
          opacity: 0.5;
        }
      }

      .response-actions {
        display: flex;
        justify-content: flex-end;

        .icon {
          height: 24px;
          width: 24px;
          cursor: pointer;
          background-repeat: no-repeat;
          background-size: 24px 24px;
          background-position: center;

          &.check {
            background-image: url(~@/assets/check.svg);
          }

          &.clear {
            background-size: 20px 20px;
            background-image: url(~@/assets/icons/exit.svg);
          }
        }

        div:not(:last-child){
          margin-right: 8px;
        }
      }
    }

    div.left {
      max-width: calc(100% - 500px);
    }
  }

  .expansion {
    display: flex;
    justify-content: space-between;
    padding-top: 12px;

    .comments {
      min-width: 400px;
      max-width: calc(100% - 500px);
    }
  }

  .project-details {
    max-width: 300px;
    margin-right: 50px;
    margin-bottom: 24px;

    label {
      text-transform: uppercase;
      font-size: 10px;
      display: block;
      font-weight: 500;
      color: #929da9;
      margin-bottom: 0px;
    }

    .title {
      font-size: 18px;
      font-weight: 500;
      color: #26292f;
      margin: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      min-width: 0;
      max-width: 100%;
      //cursor: pointer;
    }
  }

  .approval-values {
    display: flex;
    justify-content: space-between;
    min-width: 500px;

    div:not(:last-child){
      margin-right: 24px;
    }

    label {
      text-transform: uppercase;
      font-size: 10px;
      display: block;
      font-weight: 500;
      color: #929da9;
      margin-bottom: 0px;
    }

    span {
      font-size: 16px
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.slide-y-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
}

.slide-y-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
}

.slide-y-enter-to, .slide-y-leave {
  max-height: 100px;
  overflow: hidden;
}

.slide-y-enter, .slide-y-leave-to {
  overflow: hidden;
  max-height: 0;
}
</style>
